import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Switch,
  Typography,
} from "antd";
import { EditOutlined, DeleteOutlined, CheckOutlined } from "@ant-design/icons";
import { ProductPlanItem } from "../../../../api/usim/uploads/products/productPlanItem";
import { UsimSkuItem } from "../../../../api/usim/uploads/products/usimSkuItem";

const { Title, Text } = Typography;

interface ProductType {
  Id?: string;
  key: string;
  ProductType: string;
  TotalStock: number;
  hasICCI: boolean;
  status?: string;
}

interface PlanDetailModalProps {
  isVisible: boolean;
  onClose: () => void;
  usimSku: UsimSkuItem | null;
 
  onStatusChange: (usimSku: UsimSkuItem) => Promise<void>;
}

export default function PlanDetailModal({
  isVisible,
  onClose,
  usimSku,
  onStatusChange,
}: PlanDetailModalProps) {
 

  return (
    <Modal
      title="Product Plan Details"
      open={isVisible}
      onCancel={onClose}

      width={600}
    >
      {usimSku && (
        <Flex gap={16} vertical>
          {/* Action Buttons */}
          <Row justify="space-between" align="bottom">
          <Title level={4} style={{ margin: 0 }}>
              {usimSku.name}
            </Title>
            {/* create a toggle switch for the status */}
            <Switch checked={usimSku.status === "ACTIVE"} onChange={() => onStatusChange(usimSku)} />
           
           
          </Row>
          <Flex justify="space-between" align="center">
           
          <div>
              <Title level={5}>Product Details</Title>
              <Col>
                <Row >
                  <Text strong>Product Plan: {usimSku.name}</Text>
                </Row>
                <Row >
                  <Text strong>Product Type: {usimSku.typeName}</Text>
                </Row>
                <Row >
                  <Text strong>Description: {usimSku.description}</Text>
                </Row>
                <Row >
                  <Text strong>Status: {usimSku.status}</Text>
                </Row>
              </Col>
            
             
            </div>
          </Flex>
        </Flex>
      )}
    </Modal>
  );
}
